var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00c3e1",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_fluent_video_clip_24_filled")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD0D-Product-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_video_clip_24_filled",
    fill: "#00c3e1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25,4 L17.75,4 C19.4830315,4 20.8992459,5.35645477 20.9948552,7.06557609 L21,7.25 L21,16.75 C21,18.4830315 19.6435452,19.8992459 17.9344239,19.9948552 L17.75,20 L6.25,20 C4.51696854,20 3.10075407,18.6435452 3.00514479,16.9344239 L3,16.75 L3,7.25 C3,5.51696854 4.35645477,4.10075407 6.06557609,4.00514479 L6.25,4 L17.75,4 L6.25,4 Z M10.0527864,9.5854102 C10.0180725,9.65483791 10,9.73139445 10,9.80901699 L10,14.190983 C10,14.4671254 10.2238576,14.690983 10.5,14.690983 C10.5776225,14.690983 10.6541791,14.6729105 10.7236068,14.6381966 L15.1055728,12.4472136 C15.3525621,12.323719 15.4526742,12.0233825 15.3291796,11.7763932 C15.2807978,11.6796295 15.2023365,11.6011683 15.1055728,11.5527864 L10.7236068,9.3618034 C10.4766175,9.23830877 10.176281,9.33842095 10.0527864,9.5854102 Z",
    id: "\\uD83C\\uDFA8-Color"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/video.3226bf6c.svg";
export { ForwardRef as ReactComponent };